import { render, staticRenderFns } from "./DirectMail.vue?vue&type=template&id=b23fa86e&"
import script from "./DirectMail.vue?vue&type=script&lang=js&"
export * from "./DirectMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports